import classNames from "classnames";
import React from "react";
import styles from "./PagesPreview.module.scss";
export var PageThumbnail = function (_a) {
    var _b;
    var leftImg = _a.leftImg, rightImg = _a.rightImg, numberLeft = _a.numberLeft, onClick = _a.onClick, active = _a.active;
    return (React.createElement("button", { onClick: onClick, className: classNames(styles.thumbnail, (_b = {}, _b[styles.active] = active, _b)) },
        React.createElement("div", { className: styles.pagesCouple },
            React.createElement("img", { draggable: false, src: leftImg, className: styles.preview }),
            React.createElement("img", { draggable: false, src: rightImg, className: styles.preview })),
        React.createElement("span", { className: styles.pageNumbers },
            numberLeft,
            " - ",
            numberLeft + 1)));
};
